export const queryKeys = {
  employees: 'employees',
  employee: 'employee',
  users: 'users',
  user: 'user',
  roles: 'roles',
  dailyReport: 'dailyReport',
  dailyReportByEmployee: 'dailyReportByEmployee',
  cancelledReports: 'cancelledReports',
  statistics: 'statistics',
  extensions: 'extensions',
  profile: 'profile'
};
